import { render, staticRenderFns } from "./ModalHandlingPickupError.vue?vue&type=template&id=c58242d2&"
import script from "./ModalHandlingPickupError.vue?vue&type=script&lang=js&"
export * from "./ModalHandlingPickupError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports